export default __webpack_public_path__ + "static/mitsubishi-lancer-x-4dfe46fee5f2427f2d532082c3454091.jpg";